import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';
import useSettings from '../hooks/useSettings';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function Logo({ disabledLink = false, sx }: Props) {
  const { themeMode } = useSettings();

  const logo = (
    <Box>
      <img
        src={themeMode === 'dark' ? '/new2-logo-white.png' : '/new2-logo-dark.png'}
        alt="logo"
      />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
